
import {map} from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { DocumentType } from '../../models/documentType.model';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { DocumentService } from '../services/document.service';
import { Document } from '../models/Document';
import { DocumentAttribute } from '../models/DocumentAttribute';
import { DocumentTypeAttribute } from '../../models/documentTypeAttribute.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatListItem } from '@angular/material/list';
import {IFileStoreItem} from '../interfaces/IFileStoreItem';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentHistoryService } from '../services/document-history.service';
import { DocumentHistory } from '../models/DocumentHistory';
import { DocumentHistoryDetailService } from '../services/document-history-detail.service';
import { DocumentHistoryDetail } from '../models/DocumentHistoryDetail';
import { Observable } from '../../../../node_modules/rxjs/Observable';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-document-view-history',
  templateUrl: './document-view-history.component.html',
  styleUrls: ['./document-view-history.component.css']
})
export class DocumentViewHistoryComponent implements OnInit {

  @Input() isLoading = true;

  type: DocumentType = new DocumentType();
  documentForm: FormGroup;
  public document: DocumentHistoryDetail = null;
  public activeFileIndex = 0;
  public hasPreview = false;
  public thumbnail: string = null;
  private id: string = null;

  constructor(
    private notificationsService: ToastrService,
    private router: Router,
    private documentHistoryService: DocumentHistoryDetailService,
    private documentService: DocumentService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
    this.documentForm = new FormGroup({
      id: new FormControl(),
      typeId: new FormControl(),
      name: new FormControl({value: '', disabled: true}),
      files: new FormArray([]),
      attributes: new FormArray([])
    });
   }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params['id'];
    if (this.id) {
      this.GetActiveRecord(this.id);
    }
  }
  initItems(): FormGroup {

    return this.fb.group({
      typeId: new FormControl({value: '', disabled: true}, Validators.required),
      value: new FormControl({value: '', disabled: true}),
      displayValue: new FormControl({value: '', disabled: true})
           });
  }
  private GetActiveRecord(id: string) {
    this.documentHistoryService.Get(id).subscribe((result) => {
      if (result.payload) {
        this.document = result.payload;
        if (result.payload.type) {
          this.type = result.payload.type;
        }
        if (!this.document.document.attributes) {
          this.document.document.attributes = [];
        }
        const control = <FormArray>this.documentForm.controls['attributes'];
        if (this.document.document.attributes) {
          this.document.document.attributes.forEach( (attribute) => {
            const row = this.initItems();
            row.patchValue(attribute);
            control.push(row);
          });
        }
        this.documentForm.patchValue(result.payload.document);
        this.documentForm.setControl('attributes', control);
        this.RefreshFiles();
      }
    });
  }
  public OnCancel() {
    this.router.navigate(['/document/edit', this.document.parentId]);
  }
  private ConrimRestore(): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dialogMessages.restoreRecord'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
  public OnRestore() {
    this.ConrimRestore().subscribe((ret) => {
      if (ret) {
        this.documentService.Update(this.document.document).subscribe(() => {
          this.router.navigate(['/document/edit', this.document.parentId]);
        });
      }
    });
  }
  initDocument() {
    const files = <FormArray>this.documentForm.get('files');
    if (files && files.at(this.activeFileIndex)) {
      const activeFile = files.at(this.activeFileIndex).value;
      if (activeFile) {
        this.initAttachment(activeFile);
      }
    }
  }
  initAttachment(file: IFileStoreItem): void {
    this.hasPreview = this.documentService.hasPreview(file);
    this.thumbnail = this.documentService.getThumbnail(file);
  }
  RefreshFiles() {
    let currentFiles: IFileStoreItem[] = null;
    let files: any[] = null;
    if (this.document.document.files) {
      currentFiles = this.document.document.files;
      files = Object.assign({}, currentFiles);
    }
    this.documentForm.get('files').reset();
    const formFiles: FormArray = new FormArray([]);
    if (currentFiles) {
      let i = 0;
      for (const file of currentFiles) {

        const groupObject = this.fileToFormControl(file);
        const formGroup = new FormGroup(groupObject);
        formFiles.push(formGroup);
        i++;
      }
    }
    console.log('formFiles', formFiles);
    this.documentForm.setControl('files', formFiles);
    this.initDocument();
  }
  private fileToFormControl(file: IFileStoreItem): any {
    return {
      container: new FormControl(file.container),
      contentType: new FormControl(file.contentType),
      date: new FormControl(file.date),
      id: new FormControl(file.id),
      link: new FormControl(file.link),
      name: new FormControl(file.name),
      descriptione: new FormControl(file.description),
      partition: new FormControl(file.partition),
      size: new FormControl(file.size)
    };
  }
  onPrevFile() {
    this.activeFileIndex--;
    this.initDocument();
  }
  onNextFile() {
    this.activeFileIndex++;
    this.initDocument();
  }
  changeActiveFile(selected: MatSelectChange) {
    this.activeFileIndex = selected.value;
  }
  public get documentDocumentLink() {
    const id = this.id;
    return id ? this.documentHistoryService.GetDownloadLink(id) : null;
  }
  getAttributeElement(index: number): FormControl {
    const array = <FormArray>this.documentForm.get('attributes');
    return (<FormControl>array.at(index));
  }
}
